export const decodeBase64Url = (value) => {
  if (typeof value !== 'string' || value.length === 0) return null;
  try {
    let base64 = value.replace(/-/g, '+').replace(/_/g, '/');
    const padding = base64.length % 4;
    if (padding === 2) base64 += '==';
    else if (padding === 3) base64 += '=';
    else if (padding === 1) return null;

    const binary = atob(base64);
    const utf8 = binary
      .split('')
      .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join('');
    return decodeURIComponent(utf8);
  } catch (error) {
    return null;
  }
};

export const decodeVarsPayload = (value) => {
  const decoded = decodeBase64Url(value);
  if (decoded == null) return null;
  try {
    const parsed = JSON.parse(decoded);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch (error) {
    return null;
  }
};
